"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentSessionsEditor_1 = require("./BonusTournamentSessionsEditor");
var BonusTournamentSessionsList_1 = require("./BonusTournamentSessionsList");
var TournamentSessionGameLogList_1 = require("../game_logs/TournamentSessionGameLogList");
var TournamentSessionActionLogList_1 = require("../action_logs/TournamentSessionActionLogList");
var BonusTournamentSessions = /** @class */ (function (_super) {
    __extends(BonusTournamentSessions, _super);
    function BonusTournamentSessions(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentSessions.prototype.componentWillMount = function () {
        this.setState({
            edit_mode: "LIST",
            record: null,
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Сессии турнира"]);
    };
    BonusTournamentSessions.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentSessions.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentSessions.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentSessions.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentSessions.prototype.onViewLogsClick = function (item) {
        this.setState({ edit_mode: "LOGS", record: item });
    };
    BonusTournamentSessions.prototype.onViewActionsClick = function (item) {
        this.setState({ edit_mode: "ACTIONS", record: item });
    };
    BonusTournamentSessions.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentSessionsEditor_1.default, { state: this.props.state, data: this.props.dataSessions, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), dlgSelectPlayer: this.props.dlgSelectPlayer, record: null, dataPlayersAvail: this.props.dataPlayersAvail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentSessionsEditor_1.default, { state: this.props.state, data: this.props.dataSessions, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), dlgSelectPlayer: this.props.dlgSelectPlayer, record: this.state.record, dataPlayersAvail: this.props.dataPlayersAvail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentSessionsList_1.default, { state: this.props.state, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), data: this.props.dataSessions, onViewLogsClick: this.onViewLogsClick.bind(this), onViewActionsClick: this.onViewActionsClick.bind(this) }));
        }
        if (this.state.edit_mode === "LOGS") {
            return (React.createElement(TournamentSessionGameLogList_1.default, { state: this.props.state, onGoBackClick: this.onGoBackClick.bind(this), dataLogs: this.props.listTournamentGameLogsList, session: this.state.record }));
        }
        if (this.state.edit_mode === "ACTIONS") {
            return (React.createElement(TournamentSessionActionLogList_1.default, { state: this.props.state, onGoBackClick: this.onGoBackClick.bind(this), dataActions: this.props.listTournamentActionLogsList, session: this.state.record, rootSession: this.props.record }));
        }
    };
    BonusTournamentSessions.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentSessions;
}(React.Component));
exports.default = BonusTournamentSessions;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/sessions/BonusTournamentSessions.tsx
// module id = 2525
// module chunks = 0